import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { deleteCookie, getCookie } from 'globalservices/cookie';
import { isInsuracePortalUser, objectArrayFromDiffFields } from 'globalutils/fmUtils';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import Filters from './Filters';
import Form from './Form';
import RoadsideInspections from './RoadsideInspections';
import { checkServiceProvider } from './serviceProviderConfig';
import Trailers from './Trailers';
import { toggleVisibility } from './utils';

const VehicleList = lazy(() => import('./Components/VehicleList'));
const ImportVehicles = lazy(() => import('./Components/ImportVehicles'));
const TemplateImport = lazy(() => import('./Components/TemplateImport'));
const SearchWrapper = lazy(() => import('./Components/SearchWrapper'));
const layout = window?.$environment?.CURRENT_LAYOUT;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  history,
  vehicles,
  apiStatus,
  fetchVehicles,
  handleDeleteAlert,
  callback,
  filterSuccess,
  filterBoth,
  handleExportVehicle,
  handleExportTrailer,
  fetchVehicleRadius,
  handleImportVehiclePost,
  handleImportTrailerPost,
  fetchVehiclePageHistoryMap,
  vehiclePageMap,
  openDocument,
  getDrivers,
  Styled,
  i18n,
  logBook,
  handleTrailerDeleteAlert,
  pagination,
  setPagination,
  filters,
  newUI,
  fleetCompanies,
  trailerFilterSuccess,
  fetchLiveUrl,
  fetchCameraStatus,
  videoUrl,
  cameraStatus,
  clearFetchLiveUrlTimeout,
}) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const [openModalRefEmptyData, setModalRefEmptyData] = useState(false);
  const trailerSelected = getCookie('trailerSelected');
  const [value, setValue] = useState(trailerSelected ? 1 : 0);
  const [onRemove, setOnRemove] = useState('false');
  const [values, setInitialValues] = useState({
    companyId: null,
    unit_id: null,
  });

  useEffect(() => {
    deleteCookie('trailerSelected');
  }, []);

  const [driverIdSuggestion, setDriverIdSuggestion] = useState([]);

  const insuracePortalUserRole = isInsuracePortalUser();

  const fleetCompanyList = objectArrayFromDiffFields(fleetCompanies, 'id', 'name');

  useEffect(() => {
    if (vehicles.vehicleList.length && !insuracePortalUserRole) driverArray(vehicles.vehicleList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles]);

  useEffect(() => {
    const hideElement = (element, event) => {
      const popup = document.getElementById('addUsers');
      const trigger = document.getElementById('addVehiclesTarget');
      if (popup && !popup.contains(event.target) && trigger && !trigger.contains(event.target)) {
        popup.style.display = 'none';
      }
    };

    const handleClick = (event) => {
      const elements = [
        { parent: 'addVehiclesTarget', hideElm: 'addUsers' },
        { parent: 'importUserTemplateContainer', hideElm: 'importItems' },
        { parent: 'importUserContainer', hideElm: 'ImportVehicles' },
        { parent: 'exportContainer', hideElm: 'ExportVehicles' },
      ];

      elements.forEach((element) => hideElement(element, event));
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  useEffect(() => {
    if (vehiclePageMap.type === "vehicleMap") {
      closeModalEmptyData();
    }
    else if (vehiclePageMap.type === 'vehicleHistoryMap' && vehiclePageMap.data && vehiclePageMap.data.length === 0) {
      clickedModalEmptyData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiclePageMap]);

  const driverArray = (source) => {
    setDriverIdSuggestion(
      source.map((items) => ({
        label: items.unit_id,
        value: items.id,
      }))
    );
  };

  const selectChange = (e) => {
    setOnRemove('false');
    setInitialValues({
      companyId: null,
      unit_id: null,
    });
    setPagination(true);
    filterBoth(e);
  };

  const closeModalEmptyData = () => {
    setModalRefEmptyData(() => false);
  };

  const clickedModalEmptyData = () => {
    setModalRefEmptyData(() => true);
  };

  const exportVehicle = () => {
    handleExportVehicle({
      apiId: 'exportVehicle',
      callback: callback,
    });
  };

  const exportTrailer = () => {
    handleExportTrailer({
      apiId: 'exportTrailer',
      callback: callback,
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const filterVehicleByCompany = (query) => {
    setOnRemove('clear');
    const filteredList = lodash.filter(vehicles.vehicleList, query);
    filterSuccess(filteredList);
  };

  const filterTrailerByCompany = (query) => {
    const filteredList = lodash.filter(vehicles.trailerList, query);
    trailerFilterSuccess(filteredList);
  };

  const resetVehicleList = () => {
    filterSuccess(vehicles.vehicleList);
  };

  const resetTrailerList = () => {
    trailerFilterSuccess(vehicles.trailerList);
  };

  const tabValues = [
    {
      name: i18n.t('vehicles.tabs.listVehicles'),
      value: (
        <Styled.TableWrapper>
          {insuracePortalUserRole && (
            <Filters
              fleetCompanyList={fleetCompanyList}
              filterList={(data) => {
                setPagination(true);
                filterVehicleByCompany(data);
              }}
              handleReset={resetVehicleList}
              values={values}
              setInitialValues={setInitialValues}
            />
          )}
          <VehicleList
            {...{
              vehicles,
              getDrivers,
              videoUrl,
              fetchLiveUrl,
              clearFetchLiveUrlTimeout,
              callback,
              cameraStatus,
              fetchCameraStatus,
              apiStatus,
              fetchVehicles,
              handleDeleteAlert,
              setPagination,
              pagination,
            }}
          />
        </Styled.TableWrapper>
      ),
    },
    {
      name: i18n.t('vehicles.tabs.listTrailers'),
      value: (
        <Trailers
          history={history}
          callback={callback}
          trailers={vehicles?.trailerFilteredList}
          apiStatus={apiStatus}
          handleDeleteAlert={handleTrailerDeleteAlert}
          fleetCompanyList={fleetCompanyList}
          insuracePortalUserRole={insuracePortalUserRole}
          filterList={filterTrailerByCompany}
          handleReset={resetTrailerList}
        />
      ),
    },

    ...(checkServiceProvider('roadsideInspection', SERVICE_PROVIDER)
      ? [
        {
          name: i18n.t('vehicles.tabs.roadInspection'),
          value: <RoadsideInspections history={history} openDocument={openDocument} i18n={i18n} />,
        },
      ]
      : []),
  ];

  const handleExport = () => toggleVisibility('ExportVehicles');

  return (
    <>
      <Styled.Wrapper>
        <Styled.TopWrapper>
          <Styled.SearchWrapper>
            <SearchWrapper {...{ selectChange, vehicles, onRemove }} />
          </Styled.SearchWrapper>
          <Styled.ImpExpWrapper>
            <TemplateImport {...{ newUI, logBook }} />
            <ImportVehicles
              {...{
                handleImportVehiclePost,
                callback,
                handleImportTrailerPost,
              }}
            />
            <Export
              src={layout === 'NewUi' ? mediaUrls.new_export_circle : mediaUrls.new_export}
              className="importUserContainer"
              toolTip={i18n.t('common.export')}
              onClick={(e) => handleExport(e)}
              buttonName={i18n.t('common.export')}
              id="exportContainer"
              newUI={newUI}
            />
            <div id="ExportVehicles" className="vehicleModal">
              <ul>
                <li>
                  <div className={'exportLink'} onClick={() => exportVehicle()}>
                    {i18n.t('vehicles.exportVehicle')}
                  </div>
                </li>
                <li>
                  <div className={'exportLink'} onClick={() => exportTrailer()}>
                    {i18n.t('vehicles.exportTrailer')}
                  </div>
                </li>
              </ul>
            </div>
          </Styled.ImpExpWrapper>
          {layout === 'OldUi' && <Breadcrumb filters={filters} />}
        </Styled.TopWrapper>
        {checkServiceProvider('middleWrapper', SERVICE_PROVIDER) && (
          <Styled.MiddleWrapper>
            <Styled.MapWrapper>
              <GoogleMap type={vehiclePageMap.type} height={insuracePortalUserRole ? '550px' : '450px'} data={vehiclePageMap} />
            </Styled.MapWrapper>
            <Styled.TrackWrapper>
              <div className="trackVehicleForm">
                <Form
                  apiStatus={apiStatus}
                  fetchVehicleRadius={fetchVehicleRadius}
                  fetchVehiclePageHistoryMap={fetchVehiclePageHistoryMap}
                  history={history}
                  vehicles={vehicles}
                  driverIdSuggestion={driverIdSuggestion}
                  Styled={Styled}
                  fleetCompanyList={fleetCompanyList}
                  insuracePortalUserRole={insuracePortalUserRole}
                  driverArray={driverArray}
                />
              </div>
            </Styled.TrackWrapper>
          </Styled.MiddleWrapper>
        )}
        <Styled.BottomWrapper>
          <Tab data={tabValues} currentTab={value} onChange={handleChange} className="vehicleTabs" />
        </Styled.BottomWrapper>
      </Styled.Wrapper>

      {openModalRefEmptyData && <Modal
        open={openModalRefEmptyData}
        setOpen={setModalRefEmptyData}
        data={{
          header: '',
          content: () => (
            <div className="deleteParent">
              <div className="imageSection">
                <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
              </div>
              <h2> {i18n.t('common.noBreadcrumbData')} </h2>
              <div className="deletePopupBtn">
                <div className="deletebtn">
                  <Button
                    label={i18n.t('common.ok')}
                    type={'submit'}
                    onClick={() => {
                      closeModalEmptyData();
                    }}
                  ></Button>
                </div>
              </div>
            </div>
          ),
        }}
        deletePopup
        width={'450px'}
      />}

      <iframe title="importVehicleTemplateFrame" id="importVehicleTemplateFrame" style={{ display: 'none' }}></iframe>
    </>
  );
};

Component.propTypes = {
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  fetchVehicles: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  filterBoth: PropTypes.func.isRequired,
  handleExportVehicle: PropTypes.func.isRequired,
  handleExportTrailer: PropTypes.func.isRequired,
  handleImportVehicle: PropTypes.func.isRequired,
  handleImportTrailer: PropTypes.func.isRequired,
  handleImportVehiclePost: PropTypes.func.isRequired,
  handleImportTrailerPost: PropTypes.func.isRequired,
  fetchVehiclePageMap: PropTypes.func.isRequired,
  fetchVehiclePageHistoryMap: PropTypes.func.isRequired,
  vehiclePageMap: PropTypes.func.isRequired,
};
